import BaseExecutor from './base-executor';

class BaseFactory {
    createObj(objectName, initialValues) {
        return new BaseExecutor();
    }
}

export default BaseFactory;
